<dx-load-panel
    #loadPanel
    shadingColor="rgba(0,0,0,0.3)"
    [position]="{ of: '#calContainer' }"
    [visible]="blocking"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [hideOnOutsideClick]="false"
    message="กำลังโหลดข้อมูล ..."
>
</dx-load-panel>
<div #calContainer class="calculator-container">
    @if (currentPid) {
        <div class="cal-header">
            <div>
                <span
                    class="dx-icon-link icon"
                    title="เชื่อมต่อข้อมูลแล้ว"
                ></span>
                <span class="product-link-tag"># {{ currentPid }}</span>
                <span class="product-link-tag">{{ currentDisplaySku }}</span>
            </div>
            <div class="text-link-container">
                <a [class.disabled]="loading" (click)="fetchSavedParams()"
                    >โหลด</a
                >
                |
                <a [class.disabled]="loading" (click)="onEnter()">บันทึก</a>
                |
                <a
                    [routerLink]="['/embeded/price-set']"
                    [queryParams]="{ base: suggestedBasePrice }"
                    title="ตั้งราคาทุกช่องทางจากราคาหลัก — เริ่มจากราคาขาย LS ปัดขึ้น"
                    >ตั้งราคา →</a
                >
            </div>
        </div>
    }

    <hr />

    <div class="calc-row">
        <label
            title="ราคาที่ร้านค้าบน 1688 ตั้งขาย หน่วยหยวน — ค่าตั้งต้นของการคำนวณทั้งหมด (เก็บแยกรายสินค้า)"
            >ราคาขายร้านจีน</label
        >
        <div class="input-group">
            <app-calculator-input
                #pYuanPriceCtl
                [disabled]="loading"
                (enter)="onEnter()"
            >
            </app-calculator-input>
            <span>หยวน</span>
        </div>
    </div>
    <div class="calc-row">
        <label
            title="อัตราแลกเปลี่ยน หยวน → บาท — * = ค่ากลาง ใช้ร่วมกันทุกสินค้า แก้ที่นี่แล้วมีผลทั้งหมด"
            >&nbsp;&nbsp;x อัตราแลกเปลี่ยน*</label
        >
        <div class="input-group">
            <app-calculator-input
                #exchangeRateCtl
                [disabled]="loading"
                (enter)="onEnter()"
            >
            </app-calculator-input>
            <span></span>
        </div>
    </div>
    <div class="calc-row">
        <label
            title="= ราคาขายร้านจีน (หยวน) × อัตราแลกเปลี่ยน — ตัวเลขนี้คือฐานของทุก % ในกลุ่มต้นทุนด้านล่าง"
            >= ราคาขายร้านจีน</label
        >
        <div class="input-group">
            <input
                type="text"
                [disabled]="loading"
                [value]="calculatedProductCostFromChina | formatNumber: 2"
                readonly
                class="text-lg"
            />
            <span class="result-unit">บาท</span>
        </div>
    </div>

    <hr />

    <div class="calc-row">
        <label
            title="ค่าส่งภายในจีนที่ร้านค้าเรียกเก็บ — คิดเป็น % ของราคาขายร้านจีน (บาท)"
            >&nbsp;&nbsp;+ ค่าส่งในจีน</label
        >
        <div class="input-group">
            <app-calculator-input
                #shippingChinaPctCtl
                [disabled]="loading"
                (enter)="onEnter()"
            >
            </app-calculator-input>
            <span>%</span>
        </div>
    </div>
    <!-- Sits directly under ค่าส่งในจีน because the 1688 payment is exactly
         those two rows: the product plus the seller's domestic shipping.
         TrueMoney's cut is a share of that, not of the product cost the
         other percentages are each taken on, so its two working rows are
         boxed; what joins the cost is the baht row after the box. -->
    <div class="sub-calc">
        <div class="calc-row">
            <label
                title="ยอดที่จ่ายให้ร้านค้าบน 1688 จริง = ราคาขายร้านจีน (บาท) + ค่าส่งในจีน"
                >ยอดชำระ 1688</label
            >
            <div class="input-group">
                <input
                    type="text"
                    [disabled]="loading"
                    [value]="calculatedChinaPaymentAmount | formatNumber: 2"
                    readonly
                />
                <span>บาท</span>
            </div>
        </div>
        <div class="calc-row">
            <label
                title="ค่าธรรมเนียมที่ TrueMoney เก็บตอนชำระเงินให้ 1688 — คิดเป็น % ของยอดชำระ 1688 (ไม่ใช่ของราคาสินค้าอย่างเดียว) * = ค่ากลาง"
                >x ค่าธรรมเนียมชำระเงิน*</label
            >
            <div class="input-group">
                <app-calculator-input
                    #transactionFeePctCtl
                    [disabled]="loading"
                    (enter)="onEnter()"
                >
                </app-calculator-input>
                <span>%</span>
            </div>
        </div>
    </div>
    <div class="calc-row">
        <label
            title="= ยอดชำระ 1688 × % ค่าธรรมเนียมชำระเงิน — บวกเข้าต้นทุนเป็นจำนวนบาท ไม่ได้รวมอยู่ใน % อื่น"
            >&nbsp;&nbsp;+ ค่าธรรมเนียมชำระเงิน</label
        >
        <div class="input-group">
            <input
                type="text"
                [disabled]="loading"
                [value]="calculatedTransactionFee | formatNumber: 2"
                readonly
            />
            <span>บาท</span>
        </div>
    </div>

    <div class="calc-row">
        <label
            title="ค่าขนส่งจีน → ไทย — คิดเป็น % ของราคาขายร้านจีน (บาท) ไม่ใช่ % ของยอดชำระ 1688"
            >&nbsp;&nbsp;+ ค่าขนส่งมาไทย*</label
        >
        <div class="input-group">
            <app-calculator-input
                #shippingThaiPctCtl
                [disabled]="loading"
                (enter)="onEnter()"
            >
            </app-calculator-input>
            <span>%</span>
        </div>
    </div>
    <div class="calc-row">
        <label
            title="ต้นทุนอื่นที่ไม่ได้แยกรายการ เช่น ภาษีนำเข้า ค่าดำเนินการ ของเสีย — คิดเป็น % ของราคาขายร้านจีน (บาท)"
            >&nbsp;&nbsp;+ ต้นทุนแฝง*</label
        >
        <div class="input-group">
            <app-calculator-input
                #hiddenCostPctCtl
                [disabled]="loading"
                (enter)="onEnter()"
            >
            </app-calculator-input>
            <span>%</span>
        </div>
    </div>
    <div class="calc-row highlight-row">
        <label
            title="= ราคาขายร้านจีน × (1 + ค่าส่งในจีน + ค่าขนส่งมาไทย + ต้นทุนแฝง) + ค่าธรรมเนียมชำระเงิน (บาท)"
            >= ต้นทุนรวมสินค้า (C)</label
        >
        <div class="input-group">
            <input
                type="text"
                [disabled]="loading"
                [value]="calculatedTotalCost | formatNumber: 2"
                readonly
                class="text-lg"
            />
            <span>บาท</span>
        </div>
    </div>

    <hr />
    <div class="calc-row">
        <label
            title="อัตรา VAT — VAT รวมอยู่ในราคาขายแล้ว จึงถูกหักออกที่ VAT/(100+VAT) = 6.54% ของราคาขาย ไม่ใช่ 7% ใส่ 0 ถ้ายังไม่ได้จดทะเบียน VAT"
            >&nbsp;&nbsp;+ VAT*</label
        >
        <div class="input-group">
            <app-calculator-input
                #vatPctCtl
                [disabled]="loading"
                (enter)="onEnter()"
            >
            </app-calculator-input>
            <span>%</span>
        </div>
    </div>

    <hr />

    <div class="calc-row">
        <div>
            &nbsp;&nbsp;
            <label
                title="กำไรที่ต้องการ คิดเป็น % ของต้นทุนรวมสินค้า (C) — เป็นกำไรหลังหักค่าธรรมเนียมและ VAT แล้ว คลิกเพื่อเลือกกรอกแบบ %"
                [class.selected]="useExpectedProfitPct"
                [class.unselected]="!useExpectedProfitPct"
                (click)="onUseExpectedProfitPctClick($event)"
                >+ กำไรที่คาดหวัง</label
            >
        </div>

        <div class="input-group">
            <app-calculator-input
                #expectedProfitPctCtl
                [disabled]="loading || !useExpectedProfitPct"
                (enter)="onEnter()"
            >
            </app-calculator-input>

            <span
                [class.selected]="useExpectedProfitPct"
                [class.unselected]="!useExpectedProfitPct"
                >%</span
            >
        </div>
    </div>

    <div class="calc-row">
        <div>
            &nbsp;&nbsp;
            <label
                title="กำไรที่ต้องการเป็นจำนวนบาท — เป็นกำไรหลังหักค่าธรรมเนียมและ VAT แล้ว คลิกเพื่อเลือกกรอกแบบบาท"
                [class.selected]="!useExpectedProfitPct"
                [class.unselected]="useExpectedProfitPct"
                (click)="onUseExpectedProfitClick($event)"
                >+ กำไรที่คาดหวัง (P)</label
            >
        </div>

        <div class="input-group">
            <app-calculator-input
                #expectedProfitBahtCtl
                [disabled]="loading || useExpectedProfitPct"
                (enter)="onEnter()"
            >
            </app-calculator-input>
            <span
                [class.selected]="!useExpectedProfitPct"
                [class.unselected]="useExpectedProfitPct"
                >บาท</span
            >
        </div>
    </div>

    <hr />

    <div class="calc-row">
        <label
            class="font-bold"
            title="ราคาขายบน lnwshop = (C + P) ÷ (1 − VAT/(100+VAT)) — หัก VAT อย่างเดียว ไม่มีค่าธรรมเนียมแพลตฟอร์ม"
            >= ราคาขาย LS (S)</label
        >
        <div class="input-group">
            <input
                type="text"
                [disabled]="loading"
                [value]="calcuatedBahtSellingLnwShopPrice | formatNumber: 2"
                readonly
                class="font-bold text-lg"
            />
            <span>บาท</span>
        </div>
    </div>

    <hr />

    <div class="calc-row">
        <label
            title="ค่าธรรมเนียมแพลตฟอร์ม (Shopee/Lazada/TikTok) — คิดเป็น % ของราคาขายที่ผู้ซื้อจ่าย (รวม VAT แล้ว) * = ค่ากลาง"
            >&nbsp;&nbsp;+ ค่าธรรมเนียม*</label
        >
        <div class="input-group">
            <app-calculator-input
                #platformFeePctCtl
                [disabled]="loading"
                (enter)="onEnter()"
            >
            </app-calculator-input>
            <span>%</span>
        </div>
    </div>

    <div class="calc-row">
        <label
            style="text-align: right; margin-right: 40px"
            title="= ค่าธรรมเนียมแพลตฟอร์ม + VAT/(100+VAT) — VAT รวมอยู่ในราคาขายแล้ว จึงคิดที่ 6.54% ไม่ใช่ 7% ผลรวมจึงไม่เท่ากับ 22 + 7"
            >รวมที่ถูกหัก (x)</label
        >
        <div class="input-group">
            <input
                type="text"
                [disabled]="loading"
                [value]="calculatedTotalDeducted | formatNumber: 2"
                readonly
                class="text-lg"
            />
            <span>%</span>
        </div>
    </div>

    <hr />

    <div class="calc-row highlight-row"></div>
    <div class="calc-row highlight-row">
        <label
            class="font-bold"
            title="ราคาขายบนแพลตฟอร์ม = (C + P) ÷ (1 − รวมที่ถูกหัก/100) — ยังไม่ได้หักภาษีซื้อของค่าธรรมเนียมที่ขอคืนได้ กำไรจริงจะสูงกว่าที่ตั้งไว้เล็กน้อย"
            >= ราคาขาย PF (S)</label
        >
        <div class="input-group">
            <input
                type="text"
                [disabled]="loading"
                [value]="calculatedBahtSellingPlatformPrice | formatNumber: 2"
                readonly
                class="font-bold text-lg"
            />
            <span>บาท</span>
        </div>
    </div>

    <hr />

    <div style="justify-content: space-between; width: 100%">
        @if (statusText) {
            <div style="color: #333">
                @if (loading) {
                    <span class="dx-icon-refresh"> </span>
                }
                {{ statusText }}
            </div>
        }
    </div>
</div>
